module.exports = __webpack_public_path__ + "img/avatar5.daca9c64.png";